export default function getColorInCyanToYellowRange(bottomOfRange, topOfRange, value) {
  // pass the above in
  const rangeSize = topOfRange - bottomOfRange;
  const halfwayPoint = rangeSize/2 + bottomOfRange;

  let R, G, B;

  if (value <= halfwayPoint) {
    R = 0;
    G = 255;
    // B from 255 to 0
    B = 255 * (halfwayPoint - value)/(halfwayPoint - bottomOfRange);
  } else if (value <= topOfRange) {
    // R from 0 to 255
    R = 255 * (value - halfwayPoint)/(topOfRange - halfwayPoint); 
    G = 255;
    B = 0;
  } else if (value > topOfRange) {
    R = 255;
    G = 255;
    B = 0;
    console.error('value out of range');
  } else {
    R = 0;
    G = 0;
    B = 0;
    console.error('value not a number?');
  }
  return `rgb(${R},${G},${B})`;
}